import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Table,
  List,
  Button,
  message,
} from 'antd';
import { SearchOutlined, FormOutlined } from '@ant-design/icons';
import _ from 'lodash';
import './styles.module.scss';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import AppHelper from 'libs/AppHelper';
import { genFormItemAtrribute } from 'libs/FormHelper';

const FormItem = Form.Item;
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export default class NewsList extends Component {
  formRef = React.createRef();

  state = {
    tableData: {
      current: 0, //目前頁數
      page_size: 10, //一頁幾筆
      total: 0, //以此query條件，總共幾筆資料
      rows: [],
    },
    tableQuery: {
      keyword: null,
      category_ids: [],
    },
    message: '',
    keyword: '',
    sort: '',
    is_middle_banner: null,
  };
  componentDidMount() {
    AppHelper.updateConfig();
    this.loadData();
  }
  // 拉Table資料
  loadData = _.debounce((opt = { page: 1, page_size: 10 }) => {
    const tableQuery = this.formRef.current.getFieldValue();
    console.log('tableQuery', tableQuery);
    this.setState({ isLoadingData: true });

    whttp.get(
      API_HOST + '/api/mgt/v1/privileges',
      {
        page: _.get(opt, 'page', 1),
        page_size: _.get(opt, 'page_size', 10),
        keyword: _.get(tableQuery, 'keyword'),
        sort: this.state.sort,
        //category_ids : _.get(tableQuery, 'category_ids'),
        //is_middle_banner : this.state.is_middle_banner,
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }

        if (code !== 200) {
          return this.setState({ message: reason });
        }

        this.setState({ tableData: data });
      }
    );
  }, 300);

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(API_HOST + `/api/mgt/v1/news/${item.id}`, {}, (state, res) => {
      item.isDeleteData = false;
      this.setState({ isDeleteData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      message.success('刪除成功');

      this.loadData();
    });
  };
  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/news/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('複製成功');

        if (!_.isNil(data.id)) this.props.history.push(`/news/view/${data.id}`);
      }
    );
  };
  sortChange = (pagination, filters, sorter) => {
    let sort = '';
    if (!sorter) sort = '';
    else {
      let string = [];
      if (sorter.order) {
        string = sorter.order.split('end');
        sort = sorter.field + ' ' + string[0];
      } else {
        sort = '';
      }
      console.log(
        'pagination: ',
        pagination,
        'filters: ',
        filters,
        'sorter: ',
        sorter
      );
      console.log('sort = ', sort);
    }
    this.setState({ sort: sort }, () => this.loadData());
  };

  onCheckboxChange = (e) => {
    if (e.target.checked) this.setState({ is_middle_banner: 1 });
    else this.setState({ is_middle_banner: 0 });
  };

  render() {
    const { tableQuery = {}, tableData = {} } = this.state;
    const options = _.get(this, 'props.app.options', {});

    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/privileges`}>權限管理</Link>
          </Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          權限管理
          <span />
        </h2>

        <div className='block search'>
          <h3>
            搜尋
            <span />
          </h3>
          <Form
            ref={this.formRef}
            name='basic'
            className='basicForm'
            layout='vertical'
            onValuesChange={(changedFields, allFields) =>
              console.log('onValuesChange', changedFields)
            }
            onFinish={(values) => {
              this.setState({ tableQuery: values });
              this.loadData(values);
            }}
          >
            <div className='flexBox col_12'>
              <FormItem {...genFormItemAtrribute('keyword', '名稱')}>
                <Input />
              </FormItem>
            </div>
            {/* <Form.Item {...genFormItemAtrribute('category_ids', '消息類別')}>
              <Checkbox.Group>
                <List
                  grid={listGrid}
                  dataSource={_.get(options, 'news_categories', [])}
                  renderItem={item => (
                    <List.Item>
                      <Checkbox value={item.id}>{item.name}</Checkbox>
                    </List.Item>
                  )}
                />
              </Checkbox.Group>
            </Form.Item>

            <Form.Item {...genFormItemAtrribute('others', '其他')}>
              <Checkbox onChange={this.onCheckboxChange}>中版位 Banner 是否啟用</Checkbox>
            </Form.Item> */}

            <Form.Item style={{ textAlign: 'right' }}>
              <Button
                onClick={(event) => {
                  this.formRef.current.resetFields();
                  this.setState({ tableQuery: {} });
                  this.loadData();
                }}
              >
                取消
              </Button>
              <Button
                type='primary'
                style={{ marginLeft: 8 }}
                icon={<SearchOutlined />}
                htmlType='submit'
              >
                搜尋
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className='toolbar'>
          <h3>
            <span>使用者列表</span>
          </h3>
          {/* <Form layout="inline">
            <Form.Item>
              <div className="flexBox">
                <Link to={`/privileges/view/`}><Button type='primary'>新增</Button></Link>
              </div>
            </Form.Item>
          </Form> */}
        </div>

        <Table
          dataSource={tableData.rows}
          loading={this.state.isLoadingData}
          pagination={{
            current: _.get(tableData, 'current', []),
            total: _.get(tableData, 'total', 0),
            pageSize: _.get(tableData, 'page_size', 0),
            onChange: _.debounce((page, page_size) => {
              this.loadData({ page: page, page_size: page_size });
            }, 100),
          }}
          onChange={this.sortChange}
          columns={[
            // { dataIndex: 'id'            , title: '#', sorter: (a, b) => a.id - b.id},
            // { dataIndex: ['images', '0', 'url'], title: '圖片',
            //   render: image => <Avatar shape="square" src={image} component={<div class="wp-menu-image dashicons-before dashicons-megaphone"><br/></div>} />,
            // },
            { dataIndex: 'user_id', title: 'username' },
            // { dataIndex: 'category_name' , title: '分類' },
            // { dataIndex: 'status_name'   , title: '狀態' },
            // { dataIndex: 'sort'          , title: '排序' },
            { dataIndex: 'created_at', title: '建立時間' },
            { dataIndex: 'updated_at', title: '更新時間' },
            {
              title: 'Action',
              key: 'tools',
              width: 250,
              render: (text, record) => (
                <List
                  grid={{ gutter: 4, column: 3 }}
                  dataSource={[
                    // <DeleteConfirmButton
                    //   loading={record.isDeleteData === true}
                    //   size="small"
                    //   onConfirm={() => this.deleteData(record)}
                    // />,
                    <Link
                      role='button'
                      to={`/privileges/view/${record.user_id}`}
                    >
                      <Button
                        type='default'
                        size='small'
                        icon={<FormOutlined />}
                      >
                        編輯
                      </Button>
                    </Link>,
                  ]}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              ),
            },
          ]}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Privilege/PrivilegeList.js